import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  SxProps,
  Theme,
} from "@mui/material";
import { Typography } from "@platform/design-system";

export type MenuListProps = {
  menuItems: { id: string; label: string }[];
  menuTitle?: string;
  activeMenuItem?: string;
  menuWidth?: number;
  onItemClick: (id: string) => void;
  MenuListSxProps?: SxProps<Theme>;
  MenuListBoxSxProps?: SxProps<Theme>;
};

export const MenuList: React.FC<MenuListProps> = ({
  menuItems,
  menuTitle,
  activeMenuItem,
  menuWidth,
  onItemClick,
  MenuListSxProps,
  MenuListBoxSxProps,
}) => (
  <Box
    sx={{
      width: menuWidth,
      flexShrink: 0,
      position: "sticky",
      top: 0,
      alignSelf: "flex-start",
      maxHeight: "100%",
      overflow: "auto",
      ...MenuListBoxSxProps,
    }}
  >
    <List dense sx={{ ...MenuListSxProps }}>
      {menuTitle && (
        <Typography variant="body-large" sx={{ paddingLeft: 2 }}>
          {menuTitle}
        </Typography>
      )}

      {menuItems.map((item) => (
        <ListItemButton
          key={item.id}
          selected={activeMenuItem === item.id}
          onClick={() => onItemClick(item.id)}
          sx={{
            mb: 0.5,
            py: 0.5,
            borderLeft: "2px solid transparent",
            borderRadius: 0,
            "&.Mui-selected": {
              backgroundColor: "transparent",
              borderLeftColor: "brandSupporting.main",
              "&:hover": { backgroundColor: "transparent" },
            },
          }}
        >
          <ListItemText
            primary={item.label}
            slotProps={{
              primary: {
                variant: "body2",
                color:
                  activeMenuItem === item.id
                    ? "brandSupporting.main"
                    : "text.secondary",
                fontWeight: activeMenuItem === item.id ? "medium" : "regular",
              },
            }}
          />
        </ListItemButton>
      ))}
    </List>
  </Box>
);
